/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {$Container, $GraphicsBox, FC} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import {JurisdictionComponentProps} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/JurisdictionZone/components/JurisdictionZoneMain';
import {COLOR_JURISDICTION_BG} from '@gongxigames/framework/slotV2/ui/ui-koala/CONSTANTS';

export const $JurisdictionZoneAdditional: FC<JurisdictionComponentProps> = (props) => {
    const responsiveG= Store.computed(() => {
        return {
            box: {width: '100%', height: `${props.rows.value * props.panelHeight.value}px`},
        } as ResponsiveConf;
    });

    return <$Container>
        <$GraphicsBox
            responsiveBoxSize
            boxColor={COLOR_JURISDICTION_BG}
            responsive={responsiveG}
        />
    </$Container>;
};